import configData from '../../config.json';
import httpClient from './httpClient';
import { hasV1AuthParams } from '../../utils/app/queryParams';

export async function authenticate(authParams) {
  const { ekid, enpd, enfd, cmac, rid, p, c, m, originalUrl } = authParams;

  const isV1 = hasV1AuthParams(authParams);

  const path = isV1 ? '/Authenticate/v1' : '/Authenticate/v2';

  const query = isV1
    ? {
        ekid,
        enpd,
        enfd,
        cmac,
        'subscription-key': configData.subscriptionkey,
      }
    : {
        rid,
        p,
        c,
        m,
        original_url: originalUrl,
        'subscription-key': configData.subscriptionkey,
      };

  const response = await httpClient.get(path, {
    query,
    responseType: 'text',
  });

  return {
    token: response.headers.get('authorization') || '',
    status: response.status,
    correlation: response.correlationId,
  };
}
